"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));
var contests_core_1 = require("@biw/contests-core");
var contests_constants_1 = require("@biw/contests-constants");
var _a = contests_core_1.progress.finalStatus, getResultMessageCode = _a.getResultMessageCode, getResultSubmessageCode = _a.getResultSubmessageCode, getFooterMessageCode = _a.getFooterMessageCode;
var getMediaLabelObj = memoize_1.default(function (mediaLabel) { return ({ mediaLabel: mediaLabel }); });
function getFinalResultProps(state, program) {
    var programViewId = program.programViewId, programType = program.programType;
    var finalResult = contests_core_1.progress.selectors.getProgramViewFinalResults(state, programViewId);
    var finalResultCode = contests_core_1.progress.selectors.getResultCode(state, programViewId);
    var progressModel = contests_core_1.progress.selectors.getProgress(state, programViewId) || {};
    var mediaLabelObj = getMediaLabelObj(contests_core_1.client.selectors.getMediaLabel(state) || 'Points');
    var achievedGoal = progressModel.hasAchievedGoal;
    var achievedMQ = progressModel.hasAchievedMQ;
    var isMQEnabled = progressModel.hasMinimumQualifier;
    var footerMessageCode = getFooterMessageCode(programType, finalResultCode);
    return {
        tileType: 'final-result',
        showSuccess: achievedGoal && (isMQEnabled && achievedMQ) || achievedGoal && !isMQEnabled,
        pointsEarned: finalResult.totalNumberOfPoints || 0,
        pointsMediaLabel: mediaLabelObj.mediaLabel,
        resultMessageCode: getResultMessageCode(programType, finalResultCode),
        resultSubmessageCode: getResultSubmessageCode(programType, finalResultCode),
        footerMessageCode: footerMessageCode.key || footerMessageCode,
        buttonTextCode: contests_constants_1.KEY_CODES.seeResults,
        replaceOptions: mediaLabelObj
    };
}
exports.default = getFinalResultProps;
//# sourceMappingURL=final-result-props.js.map